export class BenefitsStatus{
    complete: boolean = false;
    invalidPatient: boolean = false;
    invalidInsurance: boolean = false;
    invalidCodes: boolean = false;
    invalidPatientReason: string = '';
    invalidInsuranceReason: string = '';
    invalidCodeReason:string = '';
    insuranceTermed:boolean = false;
    assistanceNeeded:boolean = false;
}